import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { USER_TYPE } from "../../../constants/common";
import classroomServices from "../../../services/classroomServices";
import Button from "../../Button";
import CustomDataTable from "../../CustomDataTable";
import Modal from "../../Modal";

const CompletionCertificateModal = forwardRef(({ onSubmit }, ref) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [classroom, setClassroom] = useState(null);
  const [students, setStudents] = useState([]); // Added missing state
  const [selectedStudents, setSelectedStudents] = useState([]);

  useImperativeHandle(ref, () => ({
    openModal(classroom) {
      setClassroom(classroom);
      setIsOpen(true);
    },
    closeModal() {
      setIsOpen(false);
    },
  }));

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const handleGenerate = () => {};

  const getClassroomStudents = async () => {
    try {
      const res = await classroomServices.getStudentsByClassroomID(classroom?.id, {
        per_page: 10,
        order_dir: "asc",
      });
      setStudents(res.data);
    } catch (error) {
      console.error("Error fetching students:", error);
    }
  };

  const handleSelectedRowsChange = (rows) => {
    setSelectedStudents(rows);
  };

  const columns = [
    {
      name: t("student_name"),
      field: "student.name",
      sortable: true,
      body: (rowData) => (
        <div className="flex items-center space-x-2">
          <span className="block w-80 overflow-hidden truncate whitespace-nowrap text-start font-medium text-blue-500">
            {rowData.student.name}
          </span>
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (isOpen) {
      getClassroomStudents();
    }
  }, [isOpen]);

  return (
    <>
      <Modal
        footer={
          <div className="flex items-center justify-end space-x-2">
            <Button color="white" variant="outlined" onClick={handleCloseModal} label={t("cancel")} />
            <Button
              label={t("create_download_certificate")}
              disabled={selectedStudents.length === 0}
              onClick={handleGenerate}
              className="w-80"
            />
          </div>
        }
        isOpen={isOpen}
        onClose={handleCloseModal}
        className="w-full max-w-2xl px-0"
        contentClassname="p-0"
        header={<h3 className="text-2xl font-bold text-blue-500">{t("completion_certificate")}</h3>}
      >
        <CustomDataTable
          onSelectedRowsChange={handleSelectedRowsChange}
          header={false}
          columns={columns}
          data={students}
          withPagination
          withSort
          withSelect
        />
      </Modal>
    </>
  );
});

export default CompletionCertificateModal;
